import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILED,
  SIGN_OUT,

  CREATE_ACCOUNT,
  // CREATE_ACCOUNT_SUCCESS,
  // CREATE_ACCOUNT_FAILED,

  VALIDATING_TOKEN,
  VALIDATING_TOKEN_SUCCESS,
  VALIDATING_TOKEN_FAILED,

  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD
} from './types';

const initialState = {
  signingIn: false,
  token: null,
  user: {},
  signingUp: false,
  error: false,
  error_msg: '',
  forgot_password_token_requesting: false,
  forgot_password_token_request_msg: '',
  forgot_password_token_request_success: false,
  resetting: false,
  reset_msg: '',
  reset_success: false,
  validating: false,
  validx: null,
  validUser: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_OUT:
      return {
        ...initialState
      };
    case SIGN_IN:
      return {
        ...state,
        signingIn: true
      };
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        signingIn: false,
        token: action.responseData.token,
        user: action.responseData.data.user
      };
    case SIGN_IN_FAILED:
      return {
        ...state,
        signingIn: false
      };

    case VALIDATING_TOKEN:
      return {
        ...state,
        validating: true
      };
    case VALIDATING_TOKEN_SUCCESS:
      return {
        ...state,
        validating: false,
        validx: true,
        validUser: action.payload.data
      };
    case VALIDATING_TOKEN_FAILED:
      return {
        ...state,
        validating: false,
        validx: false
      };

    case RESET_PASSWORD:
      return {
        ...state,
        resetting: true
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetting: false,
        reset_msg: action.hide ? '' : action.reset_msg,
        reset_success: action.hide ? false : true
      };
    case RESET_PASSWORD_FAILED:
      return {
        ...state,
        resetting: false,
        reset_msg: action.reset_msg,
        reset_success: false
      };

    case CREATE_ACCOUNT:
      return {
        ...state,
        signingUp: true
      }

    default:
      return state;
  }
};
